import { ScheduleI, ScheduleUpdate } from '~src/interfaces/schedule.interface';
import { defaultPulseCheckApi } from '~src/services/ApiController';

function pluck<S, K extends keyof S>(array: S[], key: K): Array<S[K]> {
  return array.map((item) => item[key]);
}

/**
 * POST/PUT schedule does requires to only have segment IDs in ask/share/about instead of segment models
 */
function scheduleToPostData(schedule: ScheduleI): ScheduleUpdate {
  return {
    about: schedule.about ? pluck(schedule.about, 'id') : [],
    active: schedule.active,
    anonymityMinAnswers: schedule.anonymityMinAnswers,
    anonymous: schedule.anonymous,
    ask: schedule.ask ? pluck(schedule.ask, 'id') : [],
    customSelectors: schedule.customSelectors ? pluck(schedule.customSelectors, 'id') : [],
    askManagersOfAbouts: schedule.askManagersOfAbouts,
    askManagersOfAsks: schedule.askManagersOfAsks,
    askTeamMembersOfAsks: schedule.askTeamMembersOfAsks,
    askTeamMembersOfAbouts: schedule.askTeamMembersOfAbouts,
    attributesVisibility: schedule.attributesVisibility,
    dueDate: schedule.dueDate,
    id: schedule.id,
    managersSelection: schedule.managersSelection,
    managersSelectionMail: schedule.managersSelectionMail,
    overdueAnswers: false,
    reminder: schedule.reminder,
    reminderMail: schedule.reminderMail,
    repetition: schedule.repetition,
    repetitionMail: schedule.repetitionMail,
    selfAssessment: schedule.selfAssessment,
    selfSelection: schedule.selfSelection,
    selfSelectionMail: schedule.selfSelectionMail,
    share: schedule.share ? pluck(schedule.share, 'id') : [],
    shareWithManagers: schedule.shareWithManagers,
    shareWithManagersLevels: schedule.shareWithManagersLevels,
    shareWithSubject: schedule.shareWithSubject,
    showInHeatmapToprow: schedule.showInHeatmapToprow,
    startDate: schedule.startDate,
    startMail: schedule.startMail,
    surveyId: schedule.surveyId,
    title: schedule.title,
    wasStarted: schedule.wasStarted,
    isAnonymousManagerAnswerVisible: schedule.isAnonymousManagerAnswerVisible,
    customCycles: schedule.customCycles,
    cyclesToDelete: schedule.cyclesToDelete
  };
}

export function apiCallPost(sendingData: ScheduleI, surveyId: string) {
  return defaultPulseCheckApi.postSchedule(scheduleToPostData(sendingData), surveyId);
}

export function apiCallPut(sendingData: ScheduleI) {
  return defaultPulseCheckApi.putSchedule(scheduleToPostData(sendingData));
}

export const fetchSchedule = async (scheduleId: string): Promise<ScheduleI> => {
  return (await defaultPulseCheckApi.getSchedule(scheduleId)).data;
};
